import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import loadable from '@loadable/component';

import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { timeout } from '../../lazy/lazyConstants';

export default loadable(
    () => import(/* webpackChunkName: "FindAStoreRouteLazy" */ './FindAStoreRoute'),
    {
        fallback: <Loader keepOverlay loaderClass={dt(['absolute'])} />,
        errorComponent: () => null,
        timeout,
    }
);
